/* eslint-disable */
import type { Image } from "../../cash/ui/Image.pb";

export interface LendingNullStateBlocker {
  /** The image shown above header text. Not optional. */
  image?: Image;
  /** The header text. Not optional. */
  header?: string;
  /** The subheader text. Not optional. */
  subheader?: string;
  /** The primary button. Optional. */
  primary_button?: LendingNullStateBlockerButton;
  /** Header over top of the detail rows. Optional. */
  details_header?: string;
  /** The detail rows. Not optional. */
  detail_sections?: LendingNullStateBlockerDetailSection[];
  /** The text at bottom of the page, usually FDIC wording. Not optional. */
  footer?: string;
}

/**
 * Data to populate detail rows. A cell with an icon, a title,
 * and a subtitle.
 */
export interface LendingNullStateBlockerDetailSection {
  /** The icon. Not optional. */
  icon?: LendingNullStateBlockerDetailSectionIcon;
  /** The title text. Not optional. */
  title?: string;
  /** The subtitle text. Optional. */
  subtitle?: string;
}

export enum LendingNullStateBlockerDetailSectionIcon {
  CARD = "CARD",
  DEPOSIT = "DEPOSIT",
  BANK = "BANK",
  CHECKMARK = "CHECKMARK",
}

/** The state of a button. */
export interface LendingNullStateBlockerButton {
  /** Button icon. Optional. */
  icon?: LendingNullStateBlockerButtonIcon;
  /** Whether the button is enabled for clicking. Not optional. */
  enabled?: boolean;
  /** Localizable field for Button.text */
  button_text?: string;
}

/** Icon that can be displayed on the button. */
export enum LendingNullStateBlockerButtonIcon {
  CHECKMARK = "CHECKMARK",
}
